import React from 'react';
import './Modal.css';

/**
 * Modal/Lightbox component
 */
const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} title="Schließen">
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
